import { apiRequest } from '../utils/data';
import env from '../utils/env';

const BOX = {
  FETCH_BOOST_CAMPAIGN_REQUEST: 'boost/fetch_boost_campaign_request',
  FETCH_BOOST_CAMPAIGN_SUCCESS: 'boost/fetch_boost_campaign_success',
  FETCH_BOOST_CAMPAIGN_FAILURE: 'boost/fetch_boost_campaign_failure',
};

const initialState = {
  campaign: null,
  isLoading: false,
};

export const fetchBoostCampaignRequest = () => ({
  type: BOX.FETCH_BOOST_CAMPAIGN_REQUEST,
});

export const fetchBoostCampaignSuccess = campaign => ({
  type: BOX.FETCH_BOOST_CAMPAIGN_SUCCESS,
  campaign,
});

export const fetchBoostCampaignFailure = error => ({
  type: BOX.FETCH_BOOST_CAMPAIGN_FAILURE,
  error,
});

export const getBoostCampaign = () => async (dispatch) => {
  dispatch(fetchBoostCampaignRequest());
  try {
    const response = await fetch(apiRequest(
      'GET',
      `${env.ace}/1/campaigns?type=BOOST`,
    ));
    if (response.status >= 300) {
      throw response.status;
    } else {
      const campaign = await response.json();
      dispatch(fetchBoostCampaignSuccess(campaign));
    }
  } catch (error) {
    dispatch(fetchBoostCampaignFailure(error));
  }
};

const boostReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOX.FETCH_BOOST_CAMPAIGN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case BOX.FETCH_BOOST_CAMPAIGN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        campaign: action.campaign,
      };

    case BOX.FETCH_BOOST_CAMPAIGN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default boostReducer;



// WEBPACK FOOTER //
// ./src/modules/boost.js